// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"3a752935","375":"3b928ee3","437":"412571f4","781":"9852eaf8","970":"3a752935"}[chunkId] + ".chunk.css";
};